'use strict';

function hideMoreOrLessLinks ($marketingChecklist) {
  var $tasksList = $('.list-of-tasks:not(.hidden)');
  var $tasks = $tasksList.find('.task-container');
  var $showMore = $marketingChecklist.find('.show-links-custom');
  var activeFilter =
    $marketingChecklist.find('#marketing-checklist-filter .active')
      .attr('data-tasks-category');
  var $activeTasks;
  var tasksLeft;

  if (activeFilter === 'done') {
    $activeTasks = $tasks.filter('.checked');
  } else {
    $activeTasks = $tasks.not('.checked');
  }

  tasksLeft = $activeTasks.not('.filtered-out').length;
  $showMore.toggleClass('hidden', tasksLeft <= 3);

  if (tasksLeft < 1) {
    $marketingChecklist
      .find('#marketing-checklist-filter')
      .find('[data-tasks-category=all]')
      .trigger('click');
  }
}

module.exports = hideMoreOrLessLinks;
